import type { ModuleMeta } from '../../core/types';
import { BARE_METAL_CAPABILITIES } from './capabilities';
import type { BareMetalFieldKey } from './fields';

export { BARE_METAL_CAPABILITIES };

export const BARE_METAL_MODULES = [
  {
    key: 'baseInfo',
    title: '基本信息',
    capabilities: [{ key: 'base-info', pathPrefix: '' }],
    fields: ['base.name', 'base.description', 'base.workspace', 'base.namespace', 'base.datacenter'],
    presetCheckFields: ['name'],
  },
  {
    key: 'systemSetting',
    title: '系统配置',
    capabilities: [
      { key: 'bare-metal-provisioning', pathPrefix: '' },
      {
        key: 'power-policy',
        pathPrefix: '',
      },
      {
        key: 'image',
        pathPrefix: '',
        options: {
          imageFieldPrefix: 'image',
          imageListVariant: 'common',
          legacyFlatFields: false,
          hideWhen: { field: 'provisioning.mode', value: 'Adopt' },
        },
      },
    ],
    fields: [
      'provisioning.mode',
      'boot.mode',
      'powerPolicy',
      'image.image',
      'systemVolume.architecture',
      'systemVolume.os',
      'systemVolume.version',
      'account.passwd',
      'account.privatedKey',
    ],
    presetCheckFields: ['image.url', 'image.key', 'powerPolicy', 'provisioning.mode', 'boot.mode'],
    /** 嵌套路径一次清空子字段（provisioning.mode / account.passwd 等） */
    resetFieldPaths: ['image', 'powerPolicy', 'provisioning', 'boot', 'systemVolume', 'account'],
  },
  {
    key: 'network',
    title: '网络设置',
    capabilities: [{ key: 'network', pathPrefix: '', options: { showSecurityGroup: true, showStaticIpv4WhenAdopt: true } }],
    fields: ['vpc.name', 'subnet.name', 'securitygroup.name', 'network.staticIpv4'],
    presetCheckFields: ['vpc.name'],
    resetFieldPaths: ['vpc', 'subnet', 'securitygroup', 'staticIpv4', '_staticIpv4FromNode'],
  },
  {
    key: 'bareMetalNodes',
    title: '节点配置',
    capabilities: [{ key: 'bare-metal-nodes', pathPrefix: '' }],
    fields: ['bmsNode'],
    presetCheckFields: [],
    resetFieldPaths: ['bmsNode'],
  },
  {
    key: 'service',
    title: '服务配置',
    capabilities: [{ key: 'service', pathPrefix: '', options: { listSegment: 'service', requireAtLeastOne: false } }],
    fields: ['service.list'],
    presetCheckFields: ['network.service'],
    resetFieldPaths: ['network.service'],
  },
] as const satisfies readonly ModuleMeta<BareMetalFieldKey>[];

export const BARE_METAL_MODULE_MAP = Object.fromEntries(BARE_METAL_MODULES.map((m) => [m.key, m]));
